import { Avatar, Divider, Dropdown } from 'antd';
import styled from 'styled-components';
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledDivider = styled(Divider).withConfig({
  displayName: "avatarcomponent__StyledDivider",
  componentId: "sc-1vhlt8i-0"
})(["margin:6px 0 0;"]);
var StyledUserHeader = styled.div.withConfig({
  displayName: "avatarcomponent__StyledUserHeader",
  componentId: "sc-1vhlt8i-1"
})(["display:flex;flex-direction:column;gap:2px;padding:0 6px;"]);
var StyledUserName = styled.h3.withConfig({
  displayName: "avatarcomponent__StyledUserName",
  componentId: "sc-1vhlt8i-2"
})(["margin:0;font-weight:600;font-size:16px;line-height:24px;color:#000000;"]);
var StyledUserEmail = styled.span.withConfig({
  displayName: "avatarcomponent__StyledUserEmail",
  componentId: "sc-1vhlt8i-3"
})(["font-size:13px;line-height:20px;font-weight:400;color:rgba(0,0,0,0.45);word-break:break-all;"]);
var StyledAvatar = styled(Avatar).withConfig({
  displayName: "avatarcomponent__StyledAvatar",
  componentId: "sc-1vhlt8i-4"
})(["cursor:pointer;background:#f56a00;"]);
var StyledDropdown = styled(Dropdown).withConfig({
  displayName: "avatarcomponent__StyledDropdown",
  componentId: "sc-1vhlt8i-5"
})([".ant-dropdown-menu-item{border-radius:4px !important;}"]);
export var AvatarComponent = function AvatarComponent(props) {
  var userName = props.userName,
      email = props.email,
      settingMenu = props.settingMenu;

  var renderAbbreviationOfName = function renderAbbreviationOfName() {
    if (userName) {
      var abbreviationOfName = userName.trim().split(' ').map(function (name) {
        return name[0];
      });
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("b", {
          children: abbreviationOfName
        }), /*#__PURE__*/_jsx(StyledDivider, {})]
      });
    }
  };

  var contentStyle = {
    padding: '8px',
    backgroundColor: '#ffffff',
    borderRadius: 8,
    boxShadow: '0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 9px 28px 8px rgba(0, 0, 0, 0.05)'
  };
  var menuStyle = {
    boxShadow: 'none'
  };
  return /*#__PURE__*/_jsx(StyledDropdown, {
    menu: {
      items: settingMenu
    },
    dropdownRender: function dropdownRender(menu) {
      return /*#__PURE__*/_jsxs("div", {
        style: contentStyle,
        children: [(userName || email) && /*#__PURE__*/_jsxs(StyledUserHeader, {
          children: [userName && /*#__PURE__*/_jsx(StyledUserName, {
            children: userName
          }), email && /*#__PURE__*/_jsx(StyledUserEmail, {
            children: email
          })]
        }), /*#__PURE__*/_jsx(StyledDivider, {}), /*#__PURE__*/React.cloneElement(menu, {
          style: menuStyle
        })]
      });
    },
    children: /*#__PURE__*/_jsx(StyledAvatar, {
      children: renderAbbreviationOfName()
    })
  });
};